export default () => ({
    open: false,
    reviews: null,
    error: false,
    async toggle() {
        if (this.open === false && this.reviews === null) {
            await this.loadReviews();
        }
        this.open = !this.open;
    },
    initials(name) {
        return ((name || '')
            .trim()
            .split(/\s+/)
            .map(part => [...part][0] ?? '')
            .slice(0, 2)
            .join('')
            .toUpperCase()) || '?';
    },
    async loadReviews() {
        this.error = false;
        try {
            const response = await window.axios.get('/google-reviews/index', {
                headers: {
                    'accept': 'application/json'
                }
            });
            this.reviews = response.data;
        } catch (error) {
            this.error = true;
            console.error('Error fetching reviews:', error);
        }
    }
})
